import type { Profile, IProfileRepository } from '@knownow/domain'
import { ValidationError, NotFoundError } from '@knownow/domain'

export interface CompleteProfileInput {
  readonly userId: string
  readonly displayName: string
  readonly avatarUrl?: string | undefined
}

export class CompleteProfileUseCase {
  constructor(private readonly profileRepo: IProfileRepository) {}

  async execute(input: CompleteProfileInput): Promise<Profile> {
    const displayName = input.displayName.trim()
    if (!displayName) {
      throw new ValidationError('Display name must not be empty')
    }

    const now = new Date()
    let existing: Profile | null = null

    try {
      existing = await this.profileRepo.getByUserId(input.userId)
    } catch (err) {
      if (!(err instanceof NotFoundError)) throw err
    }

    const updated: Profile = {
      userId: input.userId,
      displayName,
      avatarUrl: input.avatarUrl?.trim() ?? existing?.avatarUrl ?? null,
      defaultOrganizationId: existing?.defaultOrganizationId ?? null,
      completedAt: now,
      createdAt: existing?.createdAt ?? now,
      updatedAt: now,
    }

    await this.profileRepo.update(updated)
    return updated
  }
}
